// store.js
// store.js
import { writable } from "svelte/store";

// Inicializar como null o con un objeto vacío, según lo que necesites
export let facturaSelectedSTORE = writable(null); // o writable({})
